package com.jingfangpai.signSymptom.model

import com.jingfangpai.common.orm.mapping.SignSymptomRelation
import com.jingfangpai.common.orm.mapping.enums.SignSymptomName
import kotlinx.serialization.Serializable

@Serializable
class SignSymptomRelationDto: SignSymptomRelation() {
    var signSymptomName:SignSymptomName? = null;
    var signSymptomName2:SignSymptomName? = null;
}